import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig, appConfigTranslate } from './app/app.config';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, appConfigTranslate)
  .catch((err) => console.error(err));
